<template>
  <div
    v-bind="$attrs"
    :class="['carousel', 'slide', fade ? 'carousel-fade' : '']"
    role="region"
  >
    <ol v-if="indicators" class="carousel-indicators">
      <li
        v-for="n in slidesCount"
        :key="n"
        :class="{ active: n - 1 === internalValue }"
        @click="goTo(n - 1)"
      ></li>
    </ol>

    <div class="carousel-inner">
      <slot />
    </div>

    <a
      v-if="controls"
      class="carousel-control-prev"
      href="#"
      role="button"
      @click.prevent="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </a>
    <a
      v-if="controls"
      class="carousel-control-next"
      href="#"
      role="button"
      @click.prevent="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "BaseCarousel",
  provide() {
    return {
      registerSlide: this.registerSlide,
      unregisterSlide: this.unregisterSlide,
      getActiveIndex: () => this.internalValue,
    };
  },
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Number, default: 0 },
    interval: { type: Number, default: 0 },
    indicators: { type: Boolean, default: true },
    controls: { type: Boolean, default: true },
    fade: { type: Boolean, default: false },
    wrap: { type: Boolean, default: true },
  },
  data() {
    return {
      internalValue: this.value,
      slides: [],
      timer: null,
    };
  },
  computed: {
    slidesCount() {
      return this.slides.length;
    },
  },
  watch: {
    value(v) {
      this.internalValue = v;
    },
    internalValue(v) {
      this.$emit("input", v);
    },
  },
  mounted() {
    this.startAuto();
  },
  beforeDestroy() {
    this.stopAuto();
  },
  methods: {
    registerSlide(c) {
      this.slides.push(c);
      c.index = this.slides.length - 1;
    },
    unregisterSlide(c) {
      this.slides = this.slides.filter((x) => x !== c);
      this.slides.forEach((x, i) => (x.index = i));
    },
    goTo(idx) {
      let to = idx;
      if (to < 0) {
        if (!this.wrap) return;
        to = this.slidesCount - 1;
      }
      if (to >= this.slidesCount) {
        if (!this.wrap) return;
        to = 0;
      }
      if (to === this.internalValue) return;
      this.$emit("sliding-start", this.internalValue, to);
      this.internalValue = to;
      this.$nextTick(() => this.$emit("sliding-end", to));
    },
    next() {
      this.goTo(this.internalValue + 1);
    },
    prev() {
      this.goTo(this.internalValue - 1);
    },
    startAuto() {
      if (this.interval > 0) {
        this.timer = setInterval(this.next, this.interval);
      }
    },
    stopAuto() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>
